import BreadCrumb from "components/Common/BreadCrumb";
import React from "react";
import { useTranslation } from "react-i18next";
import { Container } from "reactstrap";

export default function TradeSetting() {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Trade Settings")} pageTitle={t("Settings")} />
        </Container>
      </div>
    </React.Fragment>
  );
}
